import React from 'react';
function ViewArrayOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M15 7v9h-5V7h5m6-2h-3v13h3V5zm-4 0H8v13h9V5zM7 5H4v13h3V5z" })));
}
export default ViewArrayOutlined;
